import { supabase } from './supabase';

export interface UserPreferences {
  id?: string;
  userId: string;
  currentSection?: string;
  preferences?: Record<string, any>;
}

// Pobierz preferencje użytkownika
export async function getUserPreferences(userId: string): Promise<UserPreferences | null> {
  try {
    const { data, error } = await supabase
      .from('user_preferences')
      .select('*')
      .eq('user_id', userId)
      .single();

    if (error) {
      if (error.code === 'PGRST116') {
        // Brak rekordu - zwróć null
        return null;
      }
      throw error;
    }

    if (!data) {
      return null;
    }

    return {
      id: data.id,
      userId: data.user_id,
      currentSection: data.current_section || undefined,
      preferences: data.preferences || {}
    };
  } catch (error) {
    console.error('Błąd pobierania preferencji użytkownika:', error);
    throw error;
  }
}

// Zapisz lub zaktualizuj preferencje użytkownika
export async function saveUserPreferences(
  userId: string,
  currentSection?: string,
  preferences?: Record<string, any>
): Promise<UserPreferences> {
  try {
    // Sprawdź czy istnieje rekord
    const existing = await getUserPreferences(userId);

    const preferencesData: any = {
      user_id: userId,
      updated_at: new Date().toISOString()
    };

    if (currentSection !== undefined) {
      preferencesData.current_section = currentSection;
    }

    if (preferences !== undefined) {
      preferencesData.preferences = preferences;
    } else if (existing?.preferences) {
      preferencesData.preferences = existing.preferences;
    } else {
      preferencesData.preferences = {};
    }

    let result;

    if (existing) {
      // Aktualizuj istniejący rekord
      const { data, error } = await supabase
        .from('user_preferences')
        .update(preferencesData)
        .eq('user_id', userId)
        .select()
        .single();

      if (error) throw error;
      result = data;
    } else {
      // Utwórz nowy rekord
      const { data, error } = await supabase
        .from('user_preferences')
        .insert(preferencesData)
        .select()
        .single();

      if (error) throw error;
      result = data;
    }

    return {
      id: result.id,
      userId: result.user_id,
      currentSection: result.current_section || undefined,
      preferences: result.preferences || {}
    };
  } catch (error) {
    console.error('Błąd zapisywania preferencji użytkownika:', error);
    throw error;
  }
}

// Zapisz tylko aktualną sekcję (uproszczona funkcja)
export async function saveCurrentSection(userId: string, section: string): Promise<void> {
  try {
    await saveUserPreferences(userId, section);
  } catch (error) {
    console.error('Błąd zapisywania aktualnej sekcji:', error);
    throw error;
  }
}
